import { Component, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { DocumentService } from '../../service/document.service';
import { ActivatedRoute, NavigationExtras, Router } from '@angular/router';
import { CustomDialogSettings } from 'src/app/shared/model/CustomDialogSettings';
import { CustomDialogService } from 'src/app/shared/services/custom-dialog.service';
import { DialogResult } from '@progress/kendo-angular-dialog';
import { SignatureInputDialogComponent } from '../signature-input-dialog/signature-input-dialog.component';
import { tap } from 'rxjs/operators';
import { SignPdfDocumentData } from '../../models/SignPdfDocumentData';
import { DocumentGenerationService } from '../../service/document-generation.service';
import { DocumentInfo } from '../../models/DocumentInfo';
import { NavigationService } from 'src/app/shared/services/navigation.service';
import { UiNotificationService } from 'src/app/external-ui-shared/services/ui-notification.service';
import { SendSignedDocumentRequest } from '../../models/SendSignedDocumentRequest';
import { DocumentKind } from 'src/app/shared/model/DocumentKind';
import { ReferenceType } from 'src/app/shared/model/ReferenceType';
import { CarReceptionDataService } from 'src/app/feature-module/claims-data/service/car-reception-data.service';


@Component({
  selector: 'app-add-customer-signature',
  templateUrl: './add-customer-signature.component.html',
  styleUrls: ['./add-customer-signature.component.scss']
})
export class AddCustomerSignatureComponent implements OnInit {

  constructor(
    private documentService: DocumentService,
    private activatedRoute: ActivatedRoute,
    private customDialogService: CustomDialogService,
    private documentGenerationService: DocumentGenerationService,
    private carReceptionDataService: CarReceptionDataService,
    private router: Router,
    private navigationService: NavigationService,
    private uiNotification: UiNotificationService
  ) { }

  documentInfoId: string;
  documentInfo: DocumentInfo;
  fileName: string;

  contentType: string;
  fieldName = "clientSignature";
  content: any;
  isError: boolean;
  isPdf: boolean;
  isLoading = false;

  @ViewChild("addCustomerSignatureDialog", { read: ViewContainerRef })
  public containerRef: ViewContainerRef;

  ngOnInit(): void {

    this.router.routeReuseStrategy.shouldReuseRoute = function () {
      return false;
    }

    this.documentInfoId = this.activatedRoute.snapshot.params.documentInfoId;
    this.isLoading = true;

    //download content from db if document id provided
    this.documentService.downloadDocument(this.documentInfoId)
      .pipe(tap(() => this.isLoading = false))
      .subscribe((res) => {
        this.setDocumentData(res);
      });

    this.documentService.getDocument(this.documentInfoId).subscribe({
      next: (res) => {
        this.documentInfo = res;
      }
    });

  }

  setDocumentData(content: Blob) {
    this.contentType = content.type;
    this.isPdf = (content.type.endsWith("pdf"));

    if (!this.isPdf) {
      this.isError = true;
    }

    this.content = content;
    //const blob = new Blob([this.content], { type: this.contentType });
    //this.downloadUrl = window.URL.createObjectURL(blob);
    return;
  }

  showSignatureArea() {
    const dialogSettings: CustomDialogSettings = {
      content: SignatureInputDialogComponent,
      maxHeight: '98vh',
      maxWidth: '98vw',
      appendTo: this.containerRef,
      dialogInputs: {

      },
      resultCallback: (r: DialogResult) => {
        if (r['text'] == 'OK') {

          const signData: SignPdfDocumentData = {
            signatureImage: r['signature'],
            signatureFieldName: 'customerSignature',
            givenByEmployeeId: 0,
            documentInfoId: this.documentInfoId
          };

          this.documentGenerationService.signGeneratedDocument(signData)
            .pipe(tap(() => this.isLoading = false))
            .subscribe({
              next: (signedDocId) => {

                if (this.router.url.includes('claimsCenter')) {
                  this.router.navigate(['claimsCenter/signDocument/' + signedDocId]);
                }

                if (this.router.url.includes('mobileCenter')) {
                  this.router.navigate(['mobileCenter/signDocument/' + signedDocId]);
                }
              }
            });
        }
      }
    };

    this.customDialogService.showDialog(dialogSettings);
  }

  goBack() {
    const historyPaths = this.navigationService.getHistory();

    let backUrl = '';
    if (historyPaths.length > 1) {
      backUrl = historyPaths.pop();
    }

    while (backUrl.includes('signDocument') && historyPaths.length > 0) {
      backUrl = historyPaths.pop();
    }

    if (this.documentInfo.isSigned) {
      const redirectionState = { redirectionFromSignedDocumentTypeId: this.documentInfo.documentTypeId };
      this.navigationService.navigateTo(backUrl, { state: redirectionState });
      return;
    }

    this.navigationService.navigateTo(backUrl);
  }

  sendSignedDocumentByEmail() {
    const task = this.uiNotification.showRunningOperation('operations.sendingOngoing');

    const sendData: SendSignedDocumentRequest = {
      documentInfoId: this.documentInfoId,
    };

    this.documentGenerationService.sendSignedDocument(sendData).subscribe(
      () => {
        this.uiNotification.showSuccess('validations.documentSent');
        this.documentService.getDocument(this.documentInfoId).subscribe({
          next: (res) => {
            this.documentInfo = res;
            this.redirectAfterEmailSent(res);
          }
        });
        task.hide()
      }
    );
  }

  redirectAfterEmailSent(documentInfo: DocumentInfo) {
    if (documentInfo.documentKindId == DocumentKind.CarReceptionData) {
      
      const claimReference = documentInfo?.references?.find(reference => reference.referenceType === ReferenceType.Claim);
      const carReceptionDataReference = documentInfo?.references?.find(reference => reference.referenceType === ReferenceType.CarReceptionData);
      if(carReceptionDataReference?.referenceId){
        const carReceptionDataId = Number(carReceptionDataReference.referenceId);
        this.carReceptionDataService.getCarReceptionData(carReceptionDataId).subscribe({
        next: (crd) => {
          if (crd.replacementCarDecision == 2) {
             if (claimReference?.referenceId && this.router.url.includes('claimsCenter')) {
              this.router.navigate(['claimsCenter/view/' + claimReference.referenceId + '/handling/claimCarRentals']);
            }

             if (claimReference?.referenceId && this.router.url.includes('mobileCenter')) {
              this.router.navigate(['mobileCenter/' + claimReference.referenceId + '/claimCarRents']);
            }
          }
          else{
            if (claimReference?.referenceId && this.router.url.includes('claimsCenter')) {
              this.router.navigate(['claimsCenter/view/' + claimReference.referenceId + '/details']);
            }
          }
        }
      });
      }
    }
  }
}
